import script from "./CloseThick.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloseThick.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__